import {InternalLinkOption} from "../option"
import {LexicalEditor} from "lexical"

import {INSERT_HORIZONTAL_RULE_COMMAND} from "@lexical/react/LexicalHorizontalRuleNode"
import {INSERT_IMAGE_COMMAND} from "../../image"
import {lexicalInsertEmojiTrigger} from "../../../actions/insert-emoji-trigger"
import {INSERT_NEW_TABLE_COMMAND} from "../../table"
import {INSERT_LAYOUT_COMMAND} from "../../layout"
import {INSERT_COLLAPSIBLE_COMMAND} from "../../collapse-container"
import {FigmaEmbedConfig, YoutubeEmbedConfig} from "../../embed"
import {INSERT_YOUTUBE_COMMAND} from "../../embed/youtube"
import {INSERT_FIGMA_COMMAND} from "../../embed/figma"
import {INSERT_PAGE_BREAK} from "../../page-break"
import {PopoverMenuItemType} from "../../../../popover-menu/popover-menu/const"
import {lexicalInsertLink} from "../../../actions/insert-link"
import slashMenu_iconComponent from "./slah-menu-icon-component"

export default function editor_insertOptions(editor: LexicalEditor) {

    const horizontalLine = new InternalLinkOption('Horizontal line', {
        id              : 'horizontalLine',
        // icon            : 'editor-i5-line fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-line'),
        keywords        : ['horizontal', 'line'],
        action          : () => {
            editor.dispatchCommand(INSERT_HORIZONTAL_RULE_COMMAND, undefined)
        }
    })

    const pageBreak = new InternalLinkOption('Page break', {
        id              : 'pageBreak',
        // icon            : 'editor-i5-page-break fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-page-break'),
        keywords        : ['page', 'break'],
        action          : () => {
            editor.dispatchCommand(INSERT_PAGE_BREAK, undefined)
        }
    })

    const image = new InternalLinkOption('Image', {
        id              : 'image',
        // icon            : 'editor-i5-image fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-image'),
        keywords        : ['image'],
        action          : () => {
            gd.modals.oneInput('Image src', '', 'Add image', (src:string)=>{
                gd.modal.hide()
                editor.dispatchCommand(INSERT_IMAGE_COMMAND, {src, altText:''})
            })
        }
    })

    const emoji = new InternalLinkOption('Emoji', {
        id              : 'emoji',
        // icon            : 'editor-i5-emoji fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-emoji'),
        keywords        : ['emoji'],
        action          : () => {
            lexicalInsertEmojiTrigger(editor)
        }
    })

    const table = new InternalLinkOption('Table', {
        id              : 'table',
        // icon            : 'editor-i5-table fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-table'),
        keywords        : ['table'],
        action          : () => {
            gd.modals.richEditor.tableSize(({rows,columns}:{rows:number, columns:number})=>{
                editor.dispatchCommand(INSERT_NEW_TABLE_COMMAND, {
                    rows            : rows,
                    columns         : columns,
                    includeHeaders  : true
                })
            })
        }
    })

    const columnLayout = new InternalLinkOption('Column layout', {
        id              : 'columnLayout',
        // icon            : 'editor-i5-column-layout fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-column-layout'),
        keywords        : ['column', 'layout'],
        action          : () => {
            gd.modals.richEditor.columnsLayout(({layoutType}:{layoutType:string})=>{
                editor.dispatchCommand(INSERT_LAYOUT_COMMAND, layoutType)
            })
        }
    })

    const collapseContainer = new InternalLinkOption('Collapse container', {
        id              : 'collapseContainer',
        // icon            : 'editor-i5-collapse-cont fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-collapse-cont'),
        keywords        : ['collapse', 'container'],
        action          : () => {
            editor.dispatchCommand(INSERT_COLLAPSIBLE_COMMAND, undefined)
        }
    })

    const youtubeVideo = new InternalLinkOption('Youtube video', {
        id              : 'youtubeVideo',
        // icon            : 'editor-i5-youtube fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-youtube'),
        keywords        : ['youtube', 'video'],
        action          : () => {
            gd.modals.oneInput('Video source', 'https://www.youtube.com/watch?v=', 'Embed Youtube Video', async (url:string)=>{
                gd.modal.hide()
                const videoData:any = await YoutubeEmbedConfig.parseUrl(url)
                if (videoData) editor.dispatchCommand(INSERT_YOUTUBE_COMMAND, videoData.id)
            })
        }
    })

    const document = new InternalLinkOption('Figma document', {
        id              : 'document',
        // icon            : 'editor-i5-figma fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-figma'),
        keywords        : ['figma', 'document'],
        action          : () => {
            gd.modals.oneInput('Figma source', 'https://www.figma.com/file/', 'Embed Figma Document', (url:string)=>{
                gd.modal.hide()
                const figmaData:any = FigmaEmbedConfig.parseUrl(url)
                if (figmaData) editor.dispatchCommand(INSERT_FIGMA_COMMAND, figmaData.id)
            })
        }
    })

    const insertWebLink = new InternalLinkOption('Insert web link', {
        id              : 'insertWebLink',
        // icon            : 'editor-i5-link',
        iconComponent   : slashMenu_iconComponent('editor-i5-link'),
        keywords        : ['insert', 'web', 'link'],
        action          : () =>{
            lexicalInsertLink(editor)
        }
    })

    const options = [
        insertWebLink,
        horizontalLine,
        pageBreak,
        image,
        table,
        emoji,
        columnLayout,
        collapseContainer,
        youtubeVideo,
        document,
    ]

    let optionsBlockKeywords: string[] = []
    _.map(options, option=>optionsBlockKeywords = optionsBlockKeywords.concat(option.keywords))

    return [
        new InternalLinkOption('Insert', {
            type        : PopoverMenuItemType.HEADER,
            keywords    : optionsBlockKeywords
        }),

        ...options,

        /*new InternalLinkOption('', {
            type        : PopoverMenuItemType.SEPARATOR,
            keywords    : optionsBlockKeywords
        }),*/
    ]
}